const NewBusinessTypeDictOptions = [{ value: '0', text: '运维' },{value:'1',text:'直拓'},{value:'4',text:'合作'},{value:'5',text:'其他'}]
const OldBusinessTypeDictOptions = [{value:'0',text:'运维'},{value:'1',text:'直拓'},{value:'2',text:'长期寿险'},{value:'3',text:'综拓'}]
const AllBusinessTypeDictOptions = [{value:'0',text:'运维'},{value:'1',text:'直拓'},{value:'2',text:'长期寿险'},{value:'3',text:'综拓'},{value:'4',text:'合作'},{value:'5',text:'其他'}]

export {
    NewBusinessTypeDictOptions,
    OldBusinessTypeDictOptions,
    AllBusinessTypeDictOptions
}